<div [inert]="maintenance.blocked()">
  @switch (appState) {
    @case ('ready') {
      <router-outlet />
    }
  }
  <hb-app-update-notice />
</div>
<hb-maintenance-notice />
